import { render, staticRenderFns } from "./OJK.vue?vue&type=template&id=3e0d9339&scoped=true&"
import script from "./OJK.vue?vue&type=script&lang=js&"
export * from "./OJK.vue?vue&type=script&lang=js&"
import style0 from "./OJK.vue?vue&type=style&index=0&id=3e0d9339&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0d9339",
  null
  
)

component.options.__file = "OJK.vue"
export default component.exports